/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_R_About_DInputs */

const en_mk_nav_r_about_d = /** @type {(inputs: Mk_Nav_R_About_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who builds this and what stage it is at.`)
};

const id_mk_nav_r_about_d = /** @type {(inputs: Mk_Nav_R_About_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siapa yang membangun ini dan sedang di tahap apa.`)
};

/**
* | output |
* | --- |
* | "Who builds this and what stage it is at." |
*
* @param {Mk_Nav_R_About_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_r_about_d = /** @type {((inputs?: Mk_Nav_R_About_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_R_About_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_r_about_d(inputs)
	return en_mk_nav_r_about_d(inputs)
});